import React, { useEffect, useState } from "react";
import { format, parseISO } from "date-fns";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { queryClient } from "../../../../../../../utils/queryClient";
//primereact
import { Row } from "primereact/row";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { ColumnGroup } from "primereact/columngroup";
import { Tooltip } from "primereact/tooltip";
//components
import Input from "../../../../../../../components/input/Input";
import Modal from "../../../../../../../components/modal/Modal";
import MaskInput from "../../../../../../../components/input/MaskInput";
import NumberInput from "../../../../../../../components/input/NumberInput";
import CalendarInput from "../../../../../../../components/input/CalendarInput";
import TextareaInput from "../../../../../../../components/input/TextareaInput";
//services
import { getUsers } from "../../../../../../../services/GeneralRegistration/getUsers";
import { getCancellations } from "../../../../../../../services/Contracts/getCancellations";
import { postCancellation } from "../../../../../../../services/Contracts/postCancellation";
import { putCancellation } from "../../../../../../../services/Contracts/putCancellation";
//utils
import { formatCurrency } from "../../../../../../../utils/formatCurrency";
import { useAppContext } from "../../../../../../../context/AppContext";

const Cancellation = ({ setActiveIndex, id, cliData, setModalActionsActive, setDefaultIndexColorActive, setTypeActionContract, setIdCancellation }) => {
  const [totalCost, setTotalCost] = useState(0);
  const [tableCost, setTableCost] = useState();
  const [showModal, setShowModal] = useState(false);
  const [successPost, setSuccessPost] = useState(false);
  const [tableDataModal, setTableDataModal] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);
  const [tableCancellation, setTableCancellation] = useState();

  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);

  const form = useForm();
  //para assistir e mudar valor da parcela diante do total a devolver
  const watchPayBack = form.watch("pay_back");
  const payBack = form.watch("value_installments");
  const quantityInstallments = form.watch("quantity_installments");

  // Função para calcular o valor dividido
  const handleQuantifyCalc = () => {
    const quantity = Number(quantityInstallments);
    const value = Number(watchPayBack);

    if (quantity > 0) {
      return value / quantity;
    }
    return value;
  };

  const errors = form.formState.errors;

  const { data: dataCancellations, isLoading: isLoadingCancellations } =
    useQuery(`cancellations${id}`, () => getCancellations(id), {
      enabled: !!permissions?.includes("56"),
    });

  const { data: users } = useQuery("clients", () => getUsers({}), {
    enabled: !!permissions.includes("10"),
  });

  const columns = [
    { field: "desc_cost", header: "Descrição" },
    { field: "percentage_cost", header: "% de Custo" },
    { field: "exibir", header: "Impacto Custo" },
    { field: "value", header: "Valor" },
  ];

  const columnsModal = [
    { field: "value_land", header: "Valor Pago" },
    { field: "value_cost", header: "Valor de Custo" },
    { field: "pay_back", header: "Total a Devolver" },
    { field: "quantity_installments", header: "QTD Parcelas" },
    { field: "value_installments", header: "Valor das Parcelas" },
    { field: "date_installments", header: "Vencimento da Primeira" },
    { field: "created_at", header: "Data do Distrato" },
  ];

  const columnsCancel = [
    { field: "value_armotized", header: "Valor Amortizado" },
    { field: "value_land", header: `Valor do ${nomenclature[1].value}` },
    { field: "value_cost", header: "Custo do Distrato" },
    { field: "pay_back", header: "Valor a Devolver" },
    { field: "created_at", header: "Data Realizada" },
    { field: "madeBy", header: "Feito por" },
    {
      field: "status",
      header: "Status",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.status) {
          case 0:
            labelClass = "badge bg-warning";
            labelText = "Em Análise";
            break;
          case 1:
            labelClass = "badge bg-danger";
            labelText = "Recusada";
            break;
          case 2:
            labelClass = "badge bg-success";
            labelText = "Aprovada";
            break;
          default:
        }
        return (
          <span
            className={labelClass}
            style={{
              fontSize: "10px",
              marginLeft: "5px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
  ];

  const formatDateString = (dateString) => {
    if (!dateString || typeof dateString !== "string") {
      return "";
    }
    const date = new Date(dateString);
    const utcString = new Date(
      date.getTime() + date.getTimezoneOffset() * 60000
    );
    const utcDate = new Date(utcString);
    return format(utcDate, "dd/MM/yyyy");
  };

  const { mutateAsync: postCancellationFn } = useMutation({
    mutationFn: postCancellation,
    onSuccess(dataSuc, variables) {
      // console.log("data: ", dataSuc);
      // console.log("variables: ",variables);
      queryClient.setQueryData([`cancellations${id}`], (data) => {
        if (data && Array.isArray(data.sale?.contract_termination)) {
          const updatedContractTermination = [
            ...data.sale.contract_termination,
          ];
          variables.date_installments = format(
            variables.date_installments,
            "dd/MM/yyyy"
          );
          variables.id = dataSuc.success.id;
          variables.user_id = dataSuc.success.user.id;
          variables.created_at = dataSuc.success.date;
          variables.status = 0;
          updatedContractTermination.push(variables);
          //          console.log(updatedContractTermination);
          return {
            ...data,
            sale: {
              ...data.sale,
              contract_termination: [...updatedContractTermination],
            },
          };
        }
        return data;
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  const { mutateAsync: putCancellationFn } = useMutation({
    mutationFn: putCancellation,
    onSuccess(_, variables) {
      queryClient.setQueryData([`cancellations${id}`], (data) => {
        if (data && Array.isArray(data.sale?.contract_termination)) {
          const updatedContractTermination = [
            ...data.sale.contract_termination,
          ];
          const index = updatedContractTermination.findIndex(
            (i) => i.id === tableDataModal[0].id
          );
          if (index !== -1) {
            updatedContractTermination[index].status = variables.termination
              ? 2
              : 1;
            setSuccessPost(!successPost);
          }
          return {
            ...data,
            sale: {
              ...data.sale,
              contract_termination: updatedContractTermination,
            },
          };
        }
        return data;
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  useEffect(() => {
    if (dataCancellations && users) {
      // console.log(dataCancellations);
      const infoFormated = dataCancellations.cost.map((item) => {
        if (item && item.value !== null) {
          if (typeof item.value === "number") {
            item.value = formatCurrency(item.value);
          } else {
            item.value = item.value;
          }
          if (typeof item.percentage_cost === "number") {
            item.percentage_cost = `${item.percentage_cost}%`;
          } else if (!item.percentage_cost.includes("%")) {
            item.percentage_cost = `${item.percentage_cost}%`;
          }
        }
        return item;
      });
      const Formated = dataCancellations.sale.contract_termination.map(
        (item) => {
          const user = users.find((client) => client.id === item.user_id);
          if (item) {
            item.madeBy = user ? user.name : "-";
            item.value_armotized =
              typeof item.value_armotized === "number"
                ? formatCurrency(item.value_armotized)
                : item.value_armotized;
            item.value_cost =
              typeof item.value_cost === "number"
                ? formatCurrency(item.value_cost)
                : item.value_cost;
            item.value_land =
              typeof item.value_land === "number"
                ? formatCurrency(item.value_land)
                : item.value_land;
            item.value_installments =
              typeof item.value_installments === "number"
                ? formatCurrency(item.value_installments)
                : item.value_installments;
            item.pay_back =
              typeof item.pay_back === "number"
                ? formatCurrency(item.pay_back)
                : item.pay_back;

            //            console.log(item.created_at);
            //            console.log("a");
            if (item.created_at && !isFormattedDate(item.created_at)) {
              item.created_at = formatDate(item.created_at);
            }
            if (
              item.date_installments &&
              !isFormattedDate(item.date_installments)
            ) {
              item.date_installments = formatDate(item.date_installments);
            }
          }
          return item;
        }
      );
      setTableCost(infoFormated);
      setTableCancellation(Formated);
      setTotalCost(dataCancellations.totalCost);
      form.setValue("value_cost", dataCancellations.totalCost);
      form.setValue(
        "pay_back",
        dataCancellations.payBack < 0 ? 0 : dataCancellations.payBack
      );
    }
  }, [dataCancellations, users, form, successPost]);

  useEffect(() => {
    form.setValue("value_installments", watchPayBack);
  }, [watchPayBack]);

  useEffect(() => {
    form.setValue("value_installments", handleQuantifyCalc());
  }, [quantityInstallments]);

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column
          footer="Total:"
          colSpan={3}
          footerStyle={{ textAlign: "right" }}
        />
        <Column footer={formatCurrency(totalCost)} />
      </Row>
    </ColumnGroup>
  );

  const onSubmit = async (data) => {
    data = {
      ...data,
      sale_id: id,
      value_land: dataCancellations.contract_value,
      value_cost: dataCancellations.totalCost,
      value_armotized: dataCancellations.totalPay,
    };
    // console.log(data);
    setLoadingButton(true);
    const notification = toast.loading("Por favor aguarde...");
    try {
      await postCancellationFn(data);
      toast.update(notification, {
        render: "Distrato enviada para análise!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoadingButton(false);
    } catch (error) {
      toast.update(notification, {
        render: error.message,
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
      return;
    }
    form.reset();
    form.clearErrors();
    form.setValue("obs", "");
    form.setValue("value_cost", dataCancellations.totalCost);
    form.setValue(
      "pay_back",
      dataCancellations.payBack < 0 ? 0 : dataCancellations.payBack
    );
  };

  const handleReview = (e, data) => {
    e.preventDefault();
    // console.log(data);
    if (data.date_installments) {
      //      console.log(data.date_installments);
      if (!isFormattedDate(data.date_installments)) {
        if (typeof data.date_installments === "string") {
          data.date_installments = formatDateString(data.date_installments);
        } else {
          data.date_installments = formatDate(data.date_installments);
        }
      }
    }
    setTableDataModal([data]);
    setShowModal(true);
  };

  const handleAccept = async () => {
    const data = {
      sale_id: id,
      termination: true,
    };
    setLoadingButton(true);
    const notification = toast.loading("Por favor aguarde...");
    try {
      await putCancellationFn(data);
      toast.update(notification, {
        render: "Distrato Aprovada com Sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoadingButton(false);
    } catch (error) {
      toast.update(notification, {
        render: error.message,
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
      return;
    }
    setShowModal(false);
  };

  const handleDeny = async () => {
    const data = {
      sale_id: id,
      termination: false,
    };
    setLoadingButton(true);
    const notification = toast.loading("Por favor aguarde...");
    try {
      await putCancellationFn(data);
      toast.update(notification, {
        render: "Distrato Recusado com Sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoadingButton(false);
    } catch (error) {
      toast.update(notification, {
        render: error.message,
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
      return;
    }
    setShowModal(false);
  };

  function formatDate(dateString) {
    try {
      const date = parseISO(dateString);
      return format(date, "dd/MM/yyyy");
    } catch (error) {
      return dateString;
    }
  }

  function isFormattedDate(dateString) {
    return /\d{2}\/\d{2}\/\d{4}/.test(dateString);
  }

  return (
    <>
      <div className="row">
        <div className="card-border me-2 my-2">
          <div className="title-container">
            <p>
              {" "}
              <i className="fa-solid fa-power-off me-2"></i>Distrato de
              Compromisso de Compra e Venda de {nomenclature[1].value}
            </p>
          </div>
          <div className="row mt-2 p-4">
            <h4 className="text-success">
              <i className="fa-regular fa-address-card mx-2"></i>Identificação
            </h4>
            <hr></hr>
            <div className="row d-flex">
              <div className="col-md-6">
                <p>
                  Valor Pago:{" "}
                  <b>
                    {dataCancellations &&
                      formatCurrency(dataCancellations.totalPay)}
                  </b>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  Valor do Contrato:{" "}
                  <b>
                    {dataCancellations &&
                      formatCurrency(dataCancellations.contract_value)}
                  </b>
                </p>
              </div>
            </div>
            <div className="mt-3">
              {tableCost ? (
                <DataTable
                  rows={5}
                  stripedRows
                  showGridlines
                  sortMode="multiple"
                  selectionMode="single"
                  value={tableCost}
                  // loading={isLoadingCancellations}
                  footerColumnGroup={footerGroup}
                  emptyMessage="Nenhuma Informação foi encontrada."
                  tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
                >
                  {columns.map((col) => (
                    <Column
                      sortable
                      key={col.field}
                      field={col.field}
                      header={col.header}
                    />
                  ))}
                </DataTable>
              ) : (
                <Skeleton width="100%" height="250px" />
              )}
            </div>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <div className="row mt-2">
                <div className="col-md-4">
                  <h4 className="mt-2" style={{ marginBottom: "-10px" }}>
                    Valor de Custos{" "}
                    <Tooltip
                      target=".custom-target"
                      position="top"
                      className=""
                    />
                    <i
                      className=" custom-target pi pi-question-circle p-text-secondary"
                      data-pr-tooltip="Soma dos valores que serão cobrados com base na porcentagem do distrato "
                      style={{ cursor: "pointer" }}
                    ></i>
                  </h4>
                  <NumberInput
                    disabled={permissions && !permissions.includes("70")} //Realizar Distrato
                    name="value_cost"
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                    useGrouping={true}
                    placeholder={0}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    control={form.control}
                    errors={errors}
                  />
                </div>
                <div className="col-md-4">
                  <h4 className="mt-2" style={{ marginBottom: "-10px" }}>
                    Total a Devolver{" "}
                    <Tooltip target=".custom-target" position="top" />
                    <i
                      className=" custom-target pi pi-question-circle p-text-secondary"
                      data-pr-tooltip="Valor pago menos o valor de custo"
                      style={{ cursor: "pointer" }}
                    ></i>
                  </h4>
                  <NumberInput
                    disabled={permissions && !permissions.includes("70")} //Realizar Distrato
                    name="pay_back"
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                    useGrouping={true}
                    placeholder={0}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    control={form.control}
                    errors={errors}
                  />
                </div>
              </div>
              <div className="mt-4">
                <div className="row">
                  <div className="col-md-12">
                    <h4 className="text-success">
                      <i className="fa-solid fa-piggy-bank mx-2"></i>Formas de
                      Pagamento
                    </h4>
                    <hr></hr>
                  </div>
                  <div className="row col-xl-9">
                      <div className="col-xl-4 col-md-6">
                        <Input
                          disabled={permissions && !permissions.includes("70")} //Realizar Distrato
                          name="bank"
                          errors={errors}
                          control={form.control}
                          isRequired={true}
                          label={`Banco`}
                        />
                      </div>
                      <div className="col-xl-4 col-md-6">
                        <NumberInput
                          disabled={permissions && !permissions.includes("70")} //Realizar Distrato
                          name="bank_account"
                          errors={errors}
                          control={form.control}
                          required={true}
                          label={`Conta`}
                        />
                      </div>
                      <div className="col-xl-4 col-md-6">
                        <MaskInput
                          disabled={permissions && !permissions.includes("70")} //Realizar Distrato
                          name="doc"
                          control={form.control}
                          isRequired={true}
                          errors={errors}
                          label="CPF"
                          mask="999.999.999-99"
                        />
                      </div>
                      <div className="col-xl-4 col-md-6">
                        <NumberInput
                          disabled={permissions && !permissions.includes("70")} //Realizar Distrato
                          name="quantity_installments"
                          errors={errors}
                          control={form.control}
                          required={true}
                          label={`N° Parcelas`}
                        />
                      </div>
                      <div className="col-xl-4 col-md-6">
                        <NumberInput
                          disabled
                          name="value_installments"
                          mode="currency"
                          currency="BRL"
                          locale="pt-BR"
                          useGrouping={true}
                          minFractionDigits={2}
                          maxFractionDigits={2}
                          label={`Valor Parcelas`}
                          control={form.control}
                          required={true}
                          errors={errors}
                        />
                      </div>
                      <div className="col-xl-4 col-md-6">
                        <CalendarInput
                          disabled={permissions && !permissions.includes("70")} //Realizar Distrato
                          name="date_installments"
                          control={form.control}
                          isRequired={true}
                          errors={errors}
                          label={`Data da Primeira`}
                        />
                      </div>
                  </div>
                  <div className="col-xl-3 mt-4 ">
                    <TextareaInput
                      disabled={permissions && !permissions.includes("70")} //Realizar Distrato
                      name="obs"
                      label="Observações"
                      errors={errors}
                      control={form.control}
                    />
                  </div>
                </div>
              </div>
              {permissions &&
                permissions.includes("70") && ( //Realizar Distrato
                  <div className="col-md-12 mt-3 text-end">
                    <Button
                      rounded
                      type="submit"
                      iconPos="right"
                      loading={loadingButton}
                      label="Finalizar"
                      icon="fa-solid fa-circle-chevron-right"
                      className="p-inputtext-sm m-auto"
                    />
                  </div>
                )}
            </form>

            <h4 className="text-success mt-2">
              {" "}
              <i className="fa-solid fa-ban mx-2"></i>Distrato
            </h4>
            <hr />
            {tableCancellation ? (
              <DataTable
                rows={5}
                paginator
                stripedRows
                showGridlines
                sortMode="multiple"
                selectionMode="single"
                rowsPerPageOptions={[5, 25, 100]}
                value={tableCancellation}
                // loading={isLoadingCancellations}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
              >
                {columnsCancel.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    body={col.body}
                    field={col.field}
                    header={col.header}
                  />
                ))}
                <Column
                  header="Ações"
                  body={(rowData) =>
                    rowData.status === 0 &&
                      permissions &&
                      permissions.includes("56") ? ( //Visualizar Distrato
                      <div className="text-center">
                        <button
                          className="btn btn-success btn-btn-sm"
                          onClick={(e) => handleReview(e, rowData)}
                        >
                          <i className="fa-solid fa-check"></i>
                        </button>
                      </div>
                    ) : rowData.status === 2 &&
                      permissions &&
                      permissions.includes("61") ? ( //Imprimir Contrato
                      <div className="text-center">
                        <button
                          className="btn btn-info btn-btn-sm"
                          onClick={(e) => {
                            setIdCancellation(rowData.id);
                            setTypeActionContract("distrato")
                            setModalActionsActive(true);
                            setDefaultIndexColorActive(1);
                          }}
                        >
                          <i className="fa fa-print"></i>
                        </button>
                      </div>
                    ) : (
                      <></>
                    )
                  }
                />
              </DataTable>
            ) : (
              <Skeleton width="100%" height="150px" />
            )}
          </div>
        </div>
      </div>
      <Modal
        visible={showModal}
        position="center"
        onHide={() => setShowModal(false)}
        dynamicWidth={window.innerWidth <= 992 ? "85vw" : "60vw"}
        dynamicTitle="Resumo do Distrato"
      >
        <DataTable
          rows={5}
          stripedRows
          showGridlines
          sortMode="multiple"
          selectionMode="single"
          value={tableDataModal}
          emptyMessage="Nenhuma Informação foi encontrada."
          tableStyle={{ minWidth: "0.8rem", fontSize: "0.72rem" }}
        >
          {columnsModal.map((col) => (
            <Column
              sortable
              key={col.field}
              body={col.body}
              field={col.field}
              header={col.header}
            />
          ))}
        </DataTable>

        <div className="row mt-4 justify-content-center">
          {permissions &&
            permissions.includes("71") && ( //Aprovar Distrato
              <div className="col-md-6 text-center">
                <Button
                  label="Aprovar"
                  className="bg-success w-50"
                  icon="fa-solid fa-check"
                  loading={loadingButton}
                  onClick={() => handleAccept()}
                  rounded
                />
              </div>
            )}
          {permissions &&
            permissions.includes("72") && ( //Recusar Distrato
              <div className="col-md-6 text-center">
                <Button
                  label="Recusar"
                  className="bg-danger w-50"
                  icon="fa-solid fa-ban"
                  loading={loadingButton}
                  onClick={() => handleDeny()}
                  style={{ border: "none" }}
                  rounded
                />
              </div>
            )}
        </div>
      </Modal>
    </>
  );
};

export default Cancellation;
